import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function AboutSection() {
  return <section id="about" className="bg-sand py-16 md:py-28" data-id="element-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-20 items-center" data-id="element-14">
          {/* Text Content */}
          <div className="order-2 lg:order-1" data-id="element-15">
            <span className="block text-gold font-semibold tracking-widest text-sm uppercase mb-4" data-id="element-16">
              About Scottsdale Patio Shades
            </span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-charcoal mb-5 sm:mb-6 leading-tight" data-id="element-17">
              Quality Window Treatments, Expert Installation
            </h2>
            <p className="text-gray-600 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8" data-id="element-18">
              We provide quality manual and motorized exterior and interior
              window treatments for residential homes, commercial buildings, and
              businesses. Our experienced, knowledgeable staff will suggest the
              best application — explaining product details, fabric transparency
              types, and most importantly, proper installation. All products
              manufactured right here in Phoenix, Arizona.
            </p>
            <a href="#contact" className="inline-flex items-center gap-2 text-gold hover:text-gold-hover font-bold text-base sm:text-lg transition-colors group min-h-[44px]" data-id="element-19">
              Learn More About Us
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-20" />
            </a>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2 relative" data-id="element-21">
            <div className="hidden sm:block absolute inset-0 bg-gold/20 rounded-2xl translate-x-4 translate-y-4 -z-10" data-id="element-22" />
            <img src="https://cdn.magicpatterns.com/uploads/o9UcUD6vUWWs4FfuPTV3tj/IMG_1550-1--1920w.webp" alt="Beautiful home exterior with premium roller shade installed" className="w-full h-auto rounded-2xl shadow-xl object-cover aspect-[4/3] sm:aspect-[4/5]" data-id="element-23" />
          </div>
        </div>
      </div>
    </section>;
}